import type { Seo } from '$lib/types'

export const load = async () => {
  return {
    seo: {
      title: 'Terms of Service',
    } satisfies Seo,
  }
}
